module.exports = __webpack_public_path__ + "img/7.045396fa.jpeg";